import React from "react";
import SvgIcon from "@material-ui/core/SvgIcon";

interface Props {
  className?: string;
}

const ClosedDoor = (props: Props) => {
  const { className } = props;

  return (
    <SvgIcon className={className} viewBox="-2 0 24 16">
      <g transform="matrix(1 0 0 1 -1726 -3316 )">
        <path
          xmlns="http://www.w3.org/2000/svg"
          d="M 19 14.5  C 19 14.22375  18.7874375 14  18.525 14  L 15 14  L 15 1.5875  C 15.2 0.711874999999998  14.560828125 0  13.775 0  L 5.224703125 0  C 4.438875 0  3.799703125 0.711874999999998  4 1.5875  L 4 14  L 0.475 14  C 0.212562500000001 14  0 14.22375  0 14.5  L 0 15.5  C 0 15.77625  0.212562500000001 16  0.475 16  L 18.525 16  C 18.7874375 16  19 15.77625  19 15.5  L 19 14.5  Z M 13.299703125 8  C 13.3 8.5521875  12.874578125 9  12.349703125 9  C 11.825125 9  11.399703125 8.5521875  11.399703125 8  C 11.399703125 7.4478125  11.825125 7  12.349703125 7  C 12.87428125 7  13.299703125 7.4478125  13.299703125 8  Z "
          fillRule="nonzero"
          fill="currentColor"
          stroke="none"
          transform="matrix(1 0 0 1 1726 3316 )"
        />
      </g>
    </SvgIcon>
  );
};

export default ClosedDoor;
